import React from 'react'
import Stars from './stars'
import PropTypes from 'prop-types'

class Rating extends React.Component {
  render() {
    return (
      <div className="rating">
        <div className="rating__reviews">
          <Stars count={this.props.count} />
          <span>(640+ Reviews)</span>
        </div>
        <span className="rating__label">
          <a href="https://www.google.com/search?ei=jV5aW9OkLtLIsQWc9p2wBw&q=trap+ink+tattoos&oq=trap+ink+tattoos&gs_l=psy-ab.3..35i39k1j0l2j0i30k1l5j38.10363.10363.0.10620.1.1.0.0.0.0.96.96.1.1.0....0...1.1.64.psy-ab..0.1.95....0.DYq6_Y7u0i4#lrd=0x88c33fdc221c451d:0x1f86b906287a1d5e,1"
            className="rating__link" target="_blank" rel="noopener noreferrer">Google</a>
          &
          <a href="https://www.facebook.com/pg/TrapInkTattoos/reviews/"
            className="rating__link" target="_blank" rel="noopener noreferrer">Facebook</a>
        </span>
      </div>
    );
  }
}

Rating.propTypes = {
  count: PropTypes.string.isRequired
}

export default Rating;



// WEBPACK FOOTER //
// ./src/components/rating/index.js